const Tradecodes = [
    { key: 'el', value: 'el', text: 'Electrician' },
    { key: 'da', value: 'da', text: 'Aids & Adaption' },
    { key: 'ar', value: 'ar', text: 'Asbestos' },
    { key: 'as', value: 'as', text: 'Asphalter' },
    { key: 'bl', value: 'bl', text: 'Brickwork-SW' },
    { key: 'co', value: 'co', text: 'Call Outs' },
    { key: 'jr', value: 'jr', text: 'Carpentry-General' },
    { key: 'cc', value: 'cc', text: 'Cleaning Or Clearance' },
    { key: 'dr', value: 'dr', text: 'Drainage-General' },
    { key: 'dr', value: 'dr', text: 'Drainage-Install' },
    { key: 'el', value: 'el', text: 'Electrical-General' },
    { key: 'el', value: 'el', text: 'Electrical-Testing' },
    { key: 'fe', value: 'fe', text: 'Fencing-Gate' },
    { key: 'wf', value: 'wf', text: 'Finishes-Ceramic' },
    { key: 'fe', value: 'fe', text: 'Fencing-General' },
    { key: 'fl', value: 'fl', text: 'Flooring' },
    { key: 'he', value: 'he', text: 'Gas-Heating' },
    { key: 'gl', value: 'gl', text: 'Glazing' },
    { key: 'pa', value: 'pa', text: 'Painting & Decorating' },
    { key: 'pt', value: 'pt', text: 'Plastering-sw' },
    { key: 'pl', value: 'pl', text: 'Plumbing-General' },
    { key: 'rf', value: 'rf', text: 'Roofing-General' },
    { key: 'sc', value: 'sc', text: 'Scaffolding' },
    { key: 'sp', value: 'sp', text: 'Specialist' },
    { key: 'sm', value: 'sm', text: 'Stonemason' },
    { key: 'in', value: 'in', text: 'Technical'}


  ]


export default Tradecodes;
